import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลต้นแหล่ง
function* materialQuotaAssignLoadLocation(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-origin-location`,
      { location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignLoadLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignLoadLocation.failure())
  }
}

// *load ข้อมูลวัตถุดิบ
function* materialQuotaAssignLoadRawMaterial(action) {
  const {
    data: { material_visibility, locations_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material`,
      { material_visibility, locations_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignLoadRawMaterial.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignLoadRawMaterial.failure())
  }
}

// *load table log
function* materialQuotaAssignLoadTableLog(action) {
  const {
    data: {
      page,
      page_size,
      order_by,
      order_type,
      type,
      limit_export,
      file_value_pdf,
      filter_obj,
      location_visibility,
      material_visibility,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/list`,
      {
        page,
        page_size,
        order_by,
        order_type,
        type,
        limit_export,
        file_value_pdf,
        filter_obj,
        location_visibility,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignLoadTableLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignLoadTableLog.failure())
  }
}

// *export
function* exportMaterialQuotaAssignLoadTableLog(action) {
  const {
    data: {
      page,
      page_size,
      order_by,
      order_type,
      type,
      limit_export,
      file_value_pdf,
      filter_obj,
      location_visibility,
      material_visibility,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/list`,
      {
        page,
        page_size,
        order_by,
        order_type,
        type,
        limit_export,
        file_value_pdf,
        filter_obj,
        location_visibility,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.exportMaterialQuotaAssignLoadTableLog.success(res.data))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.exportMaterialQuotaAssignLoadTableLog.failure())
  }
}

// *load ข้อมูลวัตถุดิบ for edit
function* materialQuotaAssignLoadRawMaterialEdit(action) {
  const {
    data: { material_visibility, locations_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material`,
      { material_visibility, locations_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignLoadRawMaterialEdit.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignLoadRawMaterialEdit.failure())
  }
}

// *preview ข้อมูลโควตา
function* materialQuotaAssignPreview(action) {
  const {
    data: { accessToken, locations_id, material_id, start_date, end_date },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/preview`,
      { locations_id, material_id, start_date, end_date },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignPreview.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignPreview.failure())
  }
}

// *update ข้อมูลโควตา
function* materialQuotaAssignUpdate(action) {
  const {
    data: { accessToken, data },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/update`,
      { data },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaAssignUpdate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaAssignUpdate.failure())
  }
}

export default function* watchMaterialQuotaAssign() {
  yield all([
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_LOCATION.REQUEST,
      materialQuotaAssignLoadLocation
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.REQUEST,
      materialQuotaAssignLoadRawMaterial
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST,
      materialQuotaAssignLoadTableLog
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.REQUEST,
      materialQuotaAssignLoadRawMaterialEdit
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_PREVIEW.REQUEST,
      materialQuotaAssignPreview
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_ASSIGN_UPDATE.REQUEST,
      materialQuotaAssignUpdate
    ),

    takeEvery(
      actions.EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST,
      exportMaterialQuotaAssignLoadTableLog
    ),
  ])
}
export {
  materialQuotaAssignLoadLocation,
  materialQuotaAssignLoadRawMaterial,
  materialQuotaAssignLoadTableLog,
  materialQuotaAssignLoadRawMaterialEdit,
  materialQuotaAssignPreview,
  materialQuotaAssignUpdate,
  exportMaterialQuotaAssignLoadTableLog,
}
